<template>
  <v-container
    id="productTemplateSectionTab"
    class="pa-0"
  >
    <base-resource-grid
      color="blue-grey"
      icon="mdi-vector-intersection"
      plural-name="Sections"
      singular-name="Section"
      allow-expand
      :headers="gridHeaders"
      :resource="productTemplateSectionResource"
      :fetch-method="getProductTemplateSection"
      :custom-columns="customColumns"
      :actions="actions"
      :prepare-save="prepareSave"
      :sort-by="['orderNo']"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
    >
      <template
        v-slot:item.answerMulti="{ item }"
      >
        {{ item.answerMulti ? 'Yes' : 'No' }}
      </template>
      <template
        v-slot:editForm="bindings"
        class="pa-0"
      >
        <product-template-section-edit
          v-model="bindings.editedItem"
          class="pa-0"
          :form-errors="bindings.formErrors"
        />
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="productTemplateSectionHistory/"
      id-field="productTemplateSectionId"
      title-field="ProductTemplateSection"
      color="blue-grey"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { ensureNumericOrNull } from '@/services/Sanitizers'

  export default {
    name: 'ProductTemplateSectionTab',

    components: {
      ProductTemplateSectionEdit: () => import('./ProductTemplateSectionEdit'),
    },

    props: {
      productTemplateId: {
        type: Number,
        default: null,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      customColumns: [
        'answerMulti',
      ],

      gridHeaders: [
        {
          text: 'Section',
          value: 'templateSection',
        },
        {
          text: 'Multiple',
          value: 'answerMulti',
        },
        {
          text: 'Order',
          value: 'orderNo',
        },
      ],

      historyColumns: [
        {
          text: 'Section',
          value: 'templateSection',
        },
        {
          text: 'Multiple',
          value: 'answerMulti',
          dataType: 'boolean',
        },
        {
          text: 'Order',
          value: 'orderNo',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      productTemplateSectionResource: new TroodyApi('productTemplateSection/'),

      historyItem: null,
    }),

    methods: {
      getProductTemplateSection () {
        return this.productTemplateSectionResource.query({ productTemplateId: this.productTemplateId })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.productTemplateId = this.productTemplateId
          ensureNumericOrNull(payload, 'orderNo')
        }
        return payload
      },
    },
  }
</script>
